import React from 'react';
import PropTypes from 'prop-types';

import Input from 'react-toolbox/lib/input/Input';
import DatePicker from 'react-toolbox/lib/date_picker/DatePicker';
import RadioGroup from 'react-toolbox/lib/radio/RadioGroup';
import RadioButton from 'react-toolbox/lib/radio/RadioButton';

import styled from 'styled-components';
import {ThreeInputGroup} from '../../Styled';

import moment from 'moment';

const DateTime = styled.div`
    margin: auto;
    display: grid;
    @media (min-width: 751px) {
        max-width: 500px;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 30px;
    }
    @media (max-width: 750px) {
        grid-template-columns: 1fr;
        text-align: center;
    }
`;

const formatDate = (date) => moment(date).format('M/D/YYYY');

const Registration = ({name, setName, phone, setPhone, email, setEmail, day, setDay, time, setTime}) => {
    return (
        <div style={{marginBottom: '50px'}}>
            <ThreeInputGroup>
                <Input type='text' label='Name' name='name' required autoComplete='name'
                       value={name} onChange={setName}/>
                <Input type='tel' label='Phone' name='phone' required autoComplete='tel'
                       value={phone} onChange={setPhone}/>
                <Input type='email' label='Email' name='email' required autoComplete='email'
                       value={email} onChange={setEmail}/>
            </ThreeInputGroup>
            <DateTime>
                <DatePicker label='Date' required autoOk value={day} onChange={setDay} inputFormat={formatDate}
                            minDate={moment().subtract(1, 'd').toDate()}
                            maxDate={moment().add(31, 'd').toDate()}/>
                <RadioGroup name='time' value={time} onChange={setTime}>
                    <RadioButton label='Morning (9AM)' value='morning' checked={time === 'morning'}/>
                    <RadioButton label='Evening (4PM)' value='evening' checked={time === 'evening'}/>
                </RadioGroup>
            </DateTime>
        </div>
    )
};

Registration.propTypes = {
    name:     PropTypes.string,
    setName:  PropTypes.func.isRequired,
    phone:    PropTypes.string,
    setPhone: PropTypes.func.isRequired,
    email:    PropTypes.string,
    setEmail: PropTypes.func.isRequired,
    day:      PropTypes.instanceOf(Date),
    setDay:   PropTypes.func.isRequired,
    time:     PropTypes.string,
    setTime:  PropTypes.func.isRequired
};

export default Registration;



// WEBPACK FOOTER //
// ./src/app/tandems/components/Registration.js